(() => {
  const isMobileSite = window.isMobileSite || false;

  /**
   * Updates search banner ad with given search term
   * @param  {string} searchTerm - Search term
   */
  const updateAdBanner = (searchTerm) => {
    if (window.fireTopSearch) {
      $('.js-search-ad-banner').html('');
      window.fireTopSearch(searchTerm);
    }
  };

  const searchResultsApp = angular.module('searchResults', ['sharedService']);

  searchResultsApp.controller('searchController', ['$scope', '$sce', '$interpolate', '$window', 'searchSync', 'dataService',
    ($scope, $sce, $interpolate, $window, searchSync, dataService) => {
      $scope.contentImagesDirectory = $window.contentImagesDirectory;
      $scope.swapPriceLabel = wmUtil.swapPriceCultures.includes(wmUtil.cultureKey);
      $scope.cultureKey = wmUtil.cultureKey;
      $scope.cultureConfig = $window.searchCultureConfig;
      $scope.signedIn = $window.PageClientData.CustomerStatus; // toggle prices on/off

      // Search params
      $scope.sortBy = $scope.cultureConfig.sortBy[0].value;
      $scope.size = 32;
      $scope.from = 0;
      $scope.products = [];
      $scope.resultCount = 0;
      $scope.data = null;
      $scope.loading = true;
      $scope.docTypes = [];
      $scope.docType = 'product';

      $scope.didYouMean = '';
      $scope.originalSpelling = '';
      $scope.hasTypo = false;

      $scope.customerPriceType = window.customerPriceType.toLowerCase();
      $scope.primaryPriceLabel = $scope.cultureConfig.priceLabels[$scope.customerPriceType];
      $scope.secondaryPriceLabel = $scope.cultureConfig.priceLabels.retail;

      /**
       * Get current search term from searchSync service
       * @return {string} - Current search term
       */
      const queryTerms = searchSync.getQuery();
      $scope.searchTerm = queryTerms.searchTerm;
      $scope.category = queryTerms.category;

      /**
       * Get current category from searchSync service
       * @return {string} - Current search category
       */
      $scope.$on('searchTermUpdate', (event, data) => {
        // Use $apply only if digest cycle is not running
        if(!$scope.$$phase) {
          $scope.$apply(() => {
            $scope.searchTerm = data.searchTerm;
            $scope.category = data.category;
          });
        } else {
          $scope.searchTerm = data.searchTerm;
          $scope.category = data.category;
        }
      });

      /**
       * Watch searchTerm and category for changes, load new results on change
       */
      $scope.$watchCollection('[searchTerm, category]', () => {
        if ($scope.didYouMean.length) {
          $scope.hasTypo = true;
        } else {
          $scope.hasTypo = false;
          $scope.originalSpelling = '';
        }

        $scope.getSearchResults(true, true);
        updateAdBanner($scope.searchTerm);
      });

      $scope.$watch('docType', (newValue, oldValue) => {
        // Only fetch new search results if the docType has actually changed
        if (newValue !== oldValue) {
          $scope.getSearchResults(true, false);
        }
      });

      $scope.getDocTypeClass = () => {
        return 'search-results--' + $scope.docType.toLowerCase().replace(/\s/g, '-');
      };

      $scope.getTemplateUrl = () => {
        return dataService.getTemplateUrl($scope.docType);
      };

      $scope.interpolate = (string) => {
        return $interpolate(string)($scope);
      };

      $scope.addToCart = (event) => {
        const target = $(event.currentTarget);
        const cartID = isMobileSite ? 'btnShowMiniCart': 'miniCartIcon';
        $window.AnimateAddToDest($get(target.attr('id')), cartID);
        $window.Melaleuca.Web.AjaxManager.AddProductToCart(target.data('sku'), target.siblings('input').val(), 'Site Search - Results', null, rtnAddToCart);
      };

      /**
       * Load next page of results
       */
      $scope.loadMoreResults = () => {
        $scope.from += $scope.size;
        $scope.getSearchResults();
      };


      /**
       * Scope function to handle fetching search results
       *
       * @param  {Boolean} shouldReload - Whether to load new result set
       */
      $scope.getSearchResults = (shouldReload, shouldUpdateDocTypes) => {
        shouldReload = shouldReload || false;
        shouldUpdateDocTypes = shouldUpdateDocTypes || false;
        if (shouldReload) {
          $scope.products = [];
          $scope.resultCount = 0;
          $scope.from = 0;
        }
        $scope.loading = true;
        fetchResults((dataResponse) => {
          /* Google Tags (added by Lance Olenik, 2/5/2020) */
          var countResults = 0;
          dataResponse.aggregations.all_docs.doc_type.buckets.forEach(function(bucket){
            countResults += bucket.doc_count;
          });
          dataLayer.push({
            'event': 'userEvent',
            'eC': 'Internal Search Results',
            'eA': countResults.toString(),
            'eL': $scope.searchTerm
          });
          /* End Google Tags */
          parseResults(dataResponse, shouldUpdateDocTypes);
        });
      };

      /**
       * Reset category filter
       */
      $scope.clearCategory = () => {
        searchSync.updateQuery($scope.searchTerm, '');
      };


      /**
       * Get search result data from search API
       * @param  {Function} callbackFunc - Callback to handle response data
       */
      const fetchResults = (callbackFunc) => {
        dataService.getSearchResults(getQueryParams())
        .success((data) => {
          if (data.error) {
            console.log(data.error);
            $scope.loading = false;
          } else {
            callbackFunc(data);
          }
        })
        .error((data, status, headers) => {
          $scope.loading = false;
          console.log('Error fetching results: ', data);
        });
      };


      /**
       * Parses search results, updating necessary scope variables
       *
       * @param {Array} results -
       */
      const parseResults = (results, shouldUpdateDocTypes) => {
        shouldUpdateDocTypes = shouldUpdateDocTypes || false;

        // Fetch other search types, if signed in
        if ($scope.signedIn) {
          const buckets = results.aggregations.all_docs.doc_type.buckets;
          const productsIndex = buckets.findIndex((bucket) => {
            return bucket.key === 'product';
          });
          // Inject 'product' into search types if not included in facet set
          if (productsIndex >= 0) {
            buckets.splice(0,0,buckets.splice(productsIndex, 1)[0]);
          } else {
            buckets.splice(0,0,{key: 'product', doc_count: 0});
          }


          $scope.docTypes = buckets;
          if (shouldUpdateDocTypes || !$scope.docTypes.length) {
            $scope.docType = buckets[0].key;
          }
        }

        // Has results--parse them
        if (results.hits.total !== 0) {
          $scope.resultCount = results.hits.total;
          const resultsArray = results.hits.hits.map((result) => {
            return wmUtil.formatFields(result._source, $scope.docType);
          });
          $scope.products = $scope.products.concat(resultsArray);
          $scope.loading = false;


          // **************************
          // PRODUCTS: Get list of
          // inventory-controlled SKUs
          // **************************
          const skuList = resultsArray.filter((result) => {
            return result.is_inventory_controlled;
          }).map((result) => {
            return result.sku;
          });
          // Check inventory status, then update data
          if (skuList.length) {
            dataService.checkInventory(skuList, $scope.products, $scope);
          }

          // **************************
          // VIDEOS: Get video info
          // using mediaId
          // **************************
          const videoList = resultsArray.filter((result) => {
            return result.media_id;
          }).map((result) => {
            return result.media_id;
          });

          if (videoList.length) {
            wmUtil.setVideoData(videoList);
          }

          // Loading new results--create page view tag
          if ($scope.from === 0) {
            createPageviewTag();
          }

          // Typo already registered--clear autocorrect term
          if ($scope.hasTypo) {
            $scope.didYouMean = '';
          }
        } else if (($scope.signedIn && $scope.docTypes.length === 1) || !$scope.signedIn) {
          // No product or other results--get autocorrection
          getDidYouMean(parseDidYouMean);
        } else {
          // No product results, but other results available--stop loading.
          $scope.loading = false;
        }
      };

      const parseDidYouMean = (response) => {
        // Update original spelling if didYouMean has not been populated
        if (!$scope.didYouMean.length) {
          $scope.originalSpelling = response.suggest.simple_phrase[0].text;
        }

        if (response.suggest.simple_phrase[0].options.length) {
          $scope.didYouMean = response.suggest.simple_phrase[0].options[0].text;
          searchSync.updateQuery($scope.didYouMean, $scope.category);
        } else {
          $scope.didYouMean = '';
          $scope.loading = false;
        }
      };


      const getDidYouMean = (callbackFunc) => {
        dataService.getSearchResults({
          id: 'did_you_mean',
          index: wmUtil.searchIndex,
          params: {
            searchTerm: $scope.searchTerm
          }
        })
        .success((data) => {
          if (data.error) {
            console.log(data.error);
          } else {
            callbackFunc(data);
          }
        })
        .error((data, status, headers) => {
          console.log('Error getting Did You Mean suggestions: ', headers);
        });
      };


      /**
       * Creates request parameters object for Elasticsearch
       *
       * @return {Object}          [description]
       */
      const getQueryParams = () => {
        const searchTerm = wmUtil.replaceFullWidthNumerals($scope.searchTerm);
        const reqParams = {
          id: 'results',
          index: wmUtil.searchIndex,
          params: {
            size: $scope.size,
            from: $scope.from,
            docType: $scope.docType,
            sortField: $interpolate($scope.sortBy.sortField)($scope),
            sortDir: $scope.sortBy.sortDir
          }
        };

        if (wmUtil.pointsRegex.test(searchTerm)) {
          reqParams.params.points = searchTerm.match(wmUtil.pointsRegex)[1];
        } else if (isNaN(searchTerm)) {
          reqParams.params.searchTerm = searchTerm;
        } else {
          reqParams.params.sku = searchTerm;
        }
        // Product-specific filters
        if ($scope.docType === 'product') {
          reqParams.params.channelId = 1;
          if (wmUtil.isDefined($scope.category)) {
            reqParams.params.category = $scope.category;
          }
        }

        return reqParams;
      };

      /**
       * Create page view tag after results have loaded
       */
      const createPageviewTag = () => {
        const clientId = $window.PageClientData.Id || 'Guest';
        const displayMode = isMobileSite ? 'Mobile' : 'Desktop';
        window.cmCreatePageviewTag('Search Results Page', 'Site Search - Results', $scope.searchTerm, $scope.resultCount, clientId + '-_-' + PageClientData.UICulture + '-_-' + $scope.category + '-_--_--_--_-' + displayMode );
      };
    }
  ]);

  angular.bootstrap(document.getElementById('search-results'),['searchResults', 'sharedService', 'ngWmUtil']);

})();
